// extracted by mini-css-extract-plugin
export var disclaimer = "DestinationFaresBox-module--disclaimer--533be";
export var header = "DestinationFaresBox-module--header--1cb11";
export var headerTitle = "DestinationFaresBox-module--header-title--be85f";
export var highlightedCruiseGroupCard = "DestinationFaresBox-module--highlighted-cruise-group-card--eab54";